import { SearchCard, APointRedeemCard } from '@commerce-product-webcomponents/ui';
import { ProductMerchandise } from '@commerce-product-webcomponents/ui-composite';
import { CarousalType, type CarousalItemProps } from './types/propsType';
import styles from './ProductCarousal.module.scss';
const CarousalItem = (props: CarousalItemProps) => {
  const {
    productItem,
    showProductIdAndSizeComp = true,
    showVariantComp = true,
    showAddToCartButtonComp = true,
    showAddToWishlistComp = true,
  } = props;
  const productEntryProps = {
    productId: productItem.productId,
    link: productItem.mainLink ?? '',
    alt: productItem.alt,
    brandName: productItem.brandName ?? '',
    productName: productItem.productName,
    productSize: productItem.productSize,
    productPrice: productItem.productPrice,
    pointValue: productItem.pointValue,
    businessVolume: productItem.businessVolume,
    variantGroupData: productItem.variantData,
  };

  const getProductCardType = () => {
    if (props.type === CarousalType.Horizontal) {
      return (
        <ProductMerchandise
          productData={productItem}
          strikethroughPrice={40}
          maxCount={20}
          disabled={false}
          showRightIcon={false}
          entryObj={productEntryProps}
        />
      );
    } else if (props.type === CarousalType.Vertical) {
      return (
        <SearchCard
          productData={productItem}
          disabled={false}
          className={styles['product-card']}
          entryObj={productEntryProps} // Cart inputs end
          showProductIdAndSizeComp={showProductIdAndSizeComp}
          showVariantComp={showVariantComp}
          showAddToCartButtonComp={showAddToCartButtonComp}
          showAddToWishlistComp={showAddToWishlistComp}
        />
      );
    } else if (props.type === CarousalType.APointCatalog) {
      return <APointRedeemCard productData={productItem} />;
    }
    return null;
  };

  if (productItem && Object.keys(productItem).length > 1 && productItem.derivedAvailabilityStatus !== 'OUT_OF_STOCK') {
    return getProductCardType();
  }
  return null;
};

export default CarousalItem;
